import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    this.modal = new Modal(this.element)

    //this.element.addEventListener('show.bs.modal', event => {
    //  document.querySelectorAll('.modal-backdrop').forEach(e => e.remove())
    //})

    this.modal.show()
  }

  disconnect() {
    this.modal.hide()
  }

  hideBeforeRender(event) {
    if (this.isOpen()) {
      event.preventDefault()
      this.element.addEventListener('hidden.bs.modal', event.detail.resume)
      this.modal.hide()
    }
  }

  hideModal() {
    this.modal.hide()
  }

  isOpen() {
    return this.element.classList.contains("show")
  }

  // hide modal when clicking ESC
  // action: "keyup@window->turbo-modal#closeWithKeyboard"
  closeWithKeyboard(e) {
    if (e.code == "Escape") {
      this.hideModal()
    }
  }

  // hide modal when clicking outside of modal
  // action: "click@window->turbo-modal#closeBackground"
  closeBackground(e) {
    if (e && this.modalTarget.contains(e.target)) {
      return;
    }
    this.hideModal()
  }

  submit(e) {
    this.modalTarget.querySelector('form').requestSubmit()
  }

  submitEnd(e) {
    if (e.detail.success) {
      if (e.params.returnUrl) {
        Turbo.visit(e.params.returnUrl, { frame: "modal"}) 
      }
      else {
        this.hideModal()
      }
    }
  }

  back(event) {
    Turbo.visit(event.params.returnUrl, { frame: "modal"}) 
  }
}